import { WalletTypes } from '@Redux/interfaces'
import { RootState } from '@Redux/store'
import { createSelector } from '@reduxjs/toolkit'

export const isLogin = (state: RootState) => state.user.login
export const currentUser = (state: RootState) => state.user || null
export const userChartInterval = (state: RootState) => state.user.chartSettings.chartInterval
export const userChartType = (state: RootState) => state.user.chartSettings.chartType

export const currentWallet = createSelector(
  currentUser,
  (user) => user?.curr_wallet ?? null
)

export const currentWalletIsMirrorTrade = createSelector(
  currentWallet,
  (wallet) => wallet?.mirror_trade
)

export const allWallets = (state: RootState) => (state.user && state.user?.wallets ? state.user.wallets : [])

export const marginWallets = (state: RootState) =>
  state.user
    ? state.user?.wallets.filter(
        (w) => w.type === WalletTypes.TYPE_MARGIN_CROSS || w.type === WalletTypes.TYPE_MARGIN_ISOLATED,
      )
    : []

export const fiatCoinWallets = (state: RootState) => {
  return state.user
    ? state.user?.wallets.filter((w) => w.type === WalletTypes.TYPE_REAL || w.type === WalletTypes.TYPE_COIN)
    : []
}

export const coinWallets = (state: RootState) => {
  return state.user ? state.user?.wallets.filter((w) => w.type === WalletTypes.TYPE_COIN) : []
}

export const exactWallet = (state: RootState, currency_code: string, walletType?: string) => {
 return  state.user
    ? state.user?.wallets?.find(
      (wallet) => wallet.currency_code === currency_code && (walletType ? wallet.type == walletType : true),
    )
    : null
}

export const getWatchlists = (state: RootState) => state.user?.watchlists ?? []
